/**
 * Выбор фона запоминается между звонками — так же, как камера/микрофон/динамик.
 * Психологу, который всегда работает с размытием, не нужно включать его заново
 * на каждой консультации.
 */
const STORAGE_KEY = 'meet-background';
export const loadStoredBackgroundMode = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (parsed?.mode === 'blur') {
            return { mode: 'blur' };
        }
        if (parsed?.mode === 'image' && typeof parsed.imagePath === 'string' && parsed.imagePath.length > 0) {
            return { mode: 'image', imagePath: parsed.imagePath };
        }
        return null;
    }
    catch (error) {
        console.warn('Failed to read stored background preference', error);
        return null;
    }
};
export const storeBackgroundMode = (mode, imagePath) => {
    try {
        if (mode === 'none') {
            localStorage.removeItem(STORAGE_KEY);
            return;
        }
        const payload = mode === 'image' ? { mode, imagePath: imagePath ?? undefined } : { mode };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }
    catch (error) {
        console.warn('Failed to persist background preference', error);
    }
};
